import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Settings.module.scss';
import ThemeSwitcher from '../../../Components/ThemeSwitcher';
import { userApi } from '../../../Utils/API';
import useLogout from '../../../hooks/useLogout';
import loadingGif from '../../../Assets/Animations/loading.gif';

const Settings = () => {
    const [profileData, setProfileData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const logout = useLogout();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                const token_type = localStorage.getItem('token_type');
                const access_token = localStorage.getItem('access_token');

                if (!token_type || !access_token) {
                    throw new Error('Authorization token not found.');
                }

                const response = await userApi.get('/api/my-profile/', {
                    headers: {
                        Authorization: `${token_type} ${access_token}`,
                    },
                });
                setProfileData(response.data);
            } catch (err) {
                if (err.response?.status === 401) {
                    logout();
                } else {
                    console.error("Failed to fetch profile data.", err);
                    setError(err);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchProfileData();
    }, []);

    return (
        <div className={styles.settingsPage}>
            <div className={styles.settingsCard}>
                <h2>Settings</h2>
                <div className={styles.settingItem}>
                    <div className={styles.settingLabel}>
                        <h3>Theme</h3>
                        <p>Choose your preferred theme for the interface.</p>
                    </div>
                    <div className={styles.settingControl}>
                        <ThemeSwitcher />
                    </div>
                </div>
                <div className={styles.settingItem}>
                    <div className={styles.settingLabel}>
                        <h3>Grace Period</h3>
                        <p>A new client secret will be automatically generated before the selected grace period ends.</p>
                    </div>
                    <div className={styles.settingControl}>
                        {loading ? (
                            <img src={loadingGif} alt="Loading..." style={{ width: '50px' }} />
                        ) : error ? (
                            <p className={styles.errorText}>Failed to load grace period.</p>
                        ) : (
                            <span className={styles.gracePeriodText}>
                                {profileData.gracePeriod || 'N/A'} Days
                                <i className={`material-icons ${styles.editIcon}`} onClick={() => navigate('/support-ticket')}>edit</i>
                            </span>
                        )}
                    </div>
                </div>
                <div className={styles.settingItem}>
                    <div className={styles.settingLabel}>
                        <h3>Notifications</h3>
                        <p>Manage your notification preferences.</p>
                    </div>
                    <div className={styles.settingControl}>
                        <label className={`${styles.toggle} ${styles.disabled}`}>
                            <input type="checkbox" disabled />
                            <span className={styles.slider}></span>
                        </label>
                        <span className={styles.comingSoon}>Coming Soon</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Settings;